import { createTheme } from '@mui/material/styles';

export const createAppTheme = (mode) => {
  const isDark = mode === 'dark';

  return createTheme({
    palette: {
      mode,
      primary: {
        main: isDark ? '#d29d5c' : '#c8904a',
        contrastText: isDark ? '#000000' : '#ffffff',
      },
      background: {
        default: isDark ? '#0a1019' : '#f7f9fc',
        paper:   isDark ? '#131a25' : '#ffffff',
      },
      text: {
        primary:   isDark ? '#ffffff'  : '#0a1020',
        secondary: isDark ? '#94a3b8'  : '#5c6b7f',
      },
      divider: isDark ? 'rgba(255,255,255,0.07)' : 'rgba(10,16,32,0.1)',
      action: {
        hover: isDark ? 'rgba(210,157,92,0.08)' : 'rgba(200,144,74,0.06)',
      },
    },
    typography: {
      fontFamily: '"Inter", sans-serif',
      h1: {
        fontFamily: '"Space Grotesk", sans-serif',
        fontWeight: 800,
        letterSpacing: '-0.025em',
        lineHeight: 1.08,
        '@media (max-width:600px)': { fontSize: '2.4rem' },
      },
      h2: {
        fontFamily: '"Space Grotesk", sans-serif',
        fontWeight: 700,
        letterSpacing: '-0.015em',
        '@media (max-width:600px)': { fontSize: '1.9rem' },
      },
      h3: { fontFamily: '"Space Grotesk", sans-serif', fontWeight: 700 },
      h4: { fontFamily: '"Space Grotesk", sans-serif', fontWeight: 700 },
      h5: { fontFamily: '"Space Grotesk", sans-serif', fontWeight: 700 },
      h6: { fontFamily: '"Space Grotesk", sans-serif', fontWeight: 600 },
      button: {
        fontFamily: '"Space Grotesk", sans-serif',
        textTransform: 'none',
        fontWeight: 700,
        letterSpacing: '0.01em',
      },
      body1: { lineHeight: 1.75 },
    },
    shape: { borderRadius: 12 },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: isDark ? '#0a1019' : '#f7f9fc',
            backgroundImage: isDark
              ? 'radial-gradient(circle at 50% -20%, rgba(210,157,92,0.12), rgba(10,16,25,0))'
              : 'none',
            backgroundRepeat: 'no-repeat',
            minHeight: '100vh',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            padding: '10px 20px',
            boxShadow: 'none',
            transition: 'all 0.18s ease',
            '&:hover': {
              boxShadow: isDark
                ? '0 4px 14px rgba(210,157,92,0.2)'
                : '0 4px 14px rgba(200,144,74,0.2)',
              transform: 'translateY(-1px)',
            },
          },
          contained: {
            backgroundColor: isDark ? '#d29d5c' : '#c8904a',
            color: isDark ? '#000000' : '#ffffff',
            '&:hover': { backgroundColor: isDark ? '#e3b578' : '#b07a38' },
          },
          outlined: {
            borderColor: isDark ? 'rgba(255,255,255,0.15)' : 'rgba(10,16,32,0.18)',
            color: isDark ? '#ffffff' : '#0a1020',
            '&:hover': {
              borderColor: isDark ? '#d29d5c' : '#c8904a',
              backgroundColor: isDark ? 'rgba(210,157,92,0.05)' : 'rgba(200,144,74,0.04)',
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
            backgroundColor: isDark ? '#131a25' : '#ffffff',
            border: isDark ? '1px solid rgba(255,255,255,0.05)' : 'none',
            borderRadius: 12,
            boxShadow: isDark
              ? 'none'
              : '0 1px 2px rgba(10,16,32,0.04), 0 4px 16px rgba(10,16,32,0.06)',
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
            boxShadow: 'none',
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: isDark ? '#0a1019' : '#ffffff',
            borderLeft: isDark
              ? '1px solid rgba(255,255,255,0.08)'
              : '1px solid rgba(10,16,32,0.08)',
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            fontFamily: '"Space Grotesk", sans-serif',
            fontWeight: 600,
            borderRadius: 8,
          },
        },
      },
      MuiDivider: {
        styleOverrides: {
          root: {
            borderColor: isDark ? 'rgba(255,255,255,0.07)' : 'rgba(10,16,32,0.09)',
          },
        },
      },
    },
  });
};

export default createAppTheme('dark');
